<template>
  <div> 
    <div class="button-container">
      <button
        v-for="(item, index) in components"
        :key="index"
        :class="{ active: currentComponent === item.component }"
        @click="currentComponent = item.component"
      >
        {{ item.name }}
      </button>
    </div> 
    <component :is="currentComponent"></component>
  </div>
</template>


<script>
import StudioAgreementManager from './StudioAgreementManager.vue';
import StudioManager from './StudioManager.vue';
import StudioProductManager from './StudioProductManager.vue';
import StudioSocialMediaManager from './StudioSocialMediaManager.vue';
import StudioWorkerManager from './StudioWorkerManager.vue';

  

export default {
  data() {
    return {
      currentComponent: 'StudioManager', 
      components: [ 
        { name: 'Stüdyolar', component: 'StudioManager' },  
        { name: 'Studio Sözleşmeleri', component: 'StudioAgreementManager' }, 
        { name: 'Sosyal Medyalar', component: 'StudioSocialMediaManager' }, 
        { name: 'Studio Çalışanları', component: 'StudioWorkerManager' }, 
        { name: 'Studio Uygulamaları', component: 'StudioProductManager' }, 
      ]
    };
  },

  components: { 
    StudioManager,
    StudioSocialMediaManager,
    StudioWorkerManager,
    StudioAgreementManager,
    StudioProductManager
  },
  
};
</script>
  
<style scoped>
.button-container {
margin: 1em 0rem;
padding: 0.8rem;
text-align: center;
display: flex; 
flex-wrap: wrap; 
} 

.button-container button {  
display: inline-block;
padding: 0.4rem 2rem;
min-width: 6rem;
margin: 0.2rem;
border: 0.06rem solid #262626;
background-color: #0b0e0f;
color: #b5b5b5;
cursor: pointer;
display: flex;
align-items: center;
justify-content: center;
} 
.button-container button:hover {
background-color: #2e2e2e;  
color: #dbdbdb;
} 
.button-container button.active {
background-color: #2e2e2e;
color: #ffffff; 
} 
@media (max-width: 360px) {
.button-container {
  flex-direction: column;
} 
.button-container button {
  width: 90%;
  margin: 0.2em auto; 
}
}
</style>
  